import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { withTranslation } from "react-i18next";

import { colors, fonts } from "../../../styles/variables";
import { I18N_NAMESPACES } from "../../../helpers/constants";
import breakpoints from "../../../styles/breakpoints";
import filterIconOpen from "../../../assets/images/icons/filter.svg";
import filterIconClose from "../../../assets/images/icons/cancel.svg";

const StyledFilterToggleButtonDesktop = styled.button`
  font-family: ${fonts.fontBauMedium};
  color: ${colors.black};
  padding: 5px 10px;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  text-transform: uppercase;
  text-align: center;
  position: relative;
  font-size: 12px;
  border: ${(props) => (props.open ? "0px" : `1px solid ${colors.black}`)};
  z-index: ${(props) => (props.open ? "3000" : "auto")};
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;

const StyledFilterToggleButtonTitle = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  font-family: ${fonts.fontInterstateUltraBlack};
  display: inline-block;
  margin-bottom: 30px;
  margin-top: 5px;
  font-weight: bolder;

  ${breakpoints.smDown} {
    display: block;
    font-size: 10px;
  }
`;

const NumberOfFiltersSelectedContainer = styled.div`
  bottom: 20%;
  display: block;
  position: absolute;
`;

const NumberOfFiltersSelected = styled(StyledFilterToggleButtonTitle)`
  font-family: ${fonts.fontBauRegular};
  font-weight: normal;
  margin-top: 2px;
  margin-bottom: 3px;
`;

const StyledFilterToggleButtonIcon = styled.div`
  ${breakpoints.smUp} {
    width: 20px;
  }
  width: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
`;

const FilterWinesToggleButton = ({
  toggleFilterWines = () => {},
  filterWinesIsOpen = false,
  numberOfSelectedFilters = 0,
  t,
}) => {
  const filterSelectedLabel = t("winePages:filterSelected", {
    count: numberOfSelectedFilters,
  });
  return (
    <StyledFilterToggleButtonDesktop
      open={filterWinesIsOpen}
      onClick={toggleFilterWines}
      filterWinesIsOpen={filterWinesIsOpen}
    >
      <div>
        <StyledFilterToggleButtonTitle>{t("winePages:filter")}</StyledFilterToggleButtonTitle>
        {Boolean(numberOfSelectedFilters) && (
          <NumberOfFiltersSelectedContainer>
            <NumberOfFiltersSelected>
              {`${numberOfSelectedFilters} ${filterSelectedLabel}`}
            </NumberOfFiltersSelected>
          </NumberOfFiltersSelectedContainer>
        )}
      </div>
      <StyledFilterToggleButtonIcon>
        <img alt="Filter icon" src={!filterWinesIsOpen ? filterIconOpen : filterIconClose} />
      </StyledFilterToggleButtonIcon>
    </StyledFilterToggleButtonDesktop>
  );
};

FilterWinesToggleButton.propTypes = {
  toggleFilterWines: PropTypes.func,
  filterWinesIsOpen: PropTypes.bool,
  numberOfSelectedFilters: PropTypes.number,
  t: PropTypes.func.isRequired,
};

export default withTranslation(I18N_NAMESPACES.WINE_PAGES)(FilterWinesToggleButton);
